import script from "./sidebar-full-base.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebar-full-base.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__